import httpAuth from "@/common/http/http-common";
import { RatingDataDto, RatingDto, RatingFormDto } from "@/types/rating.type";
import { UserDetailDto } from "@/types/user.type";

class RatingService {
  client = httpAuth("rating");

  async getOpenByOfficeAsync(officeId: number): Promise<RatingDto[]> {
    const { data } = await this.client.get(`office/${officeId}/open`);

    return data;
  }

  async getByPracticeAsync(practiceId: number): Promise<RatingDto[]> {
    const { data } = await this.client.get(`practice/${practiceId}/dental-temp/all`);

    return data;
  }

  async getUserDetailsAsync(practiceId: number, userId: number, officeId: number | null = null): Promise<UserDetailDto> {
    let uri = `practice/${practiceId}/user/${userId}/details`;

    if (officeId) {
        uri += `?officeId=${officeId}`;
    }

    const { data } = await this.client.get(uri);

    return data;
  }

  async updateAsync(form: RatingFormDto): Promise<void> {
    await this.client.put(".", form);
  }

  async getDataAsync(): Promise<RatingDataDto> {
    const { data } = await this.client.get("data");

    return data;
  }
}

export default new RatingService();